export const OptionsDropdown = [
  {
    index: 0,
    text: 'Concluída'
  },
  {
    index: 1,
    text: 'Reagendar',
  }
]